import { bearlog } from "@sillyscribe95/bear-ui-web";
import { majorRend, minorRend, seventhRend, susRend } from "./chordFuncs";

export function mapBase(asdfe, push = 0) {
  let oaksd = {};
  asdfe.map(mapBass);

  //
  function mapBass(num, ind) {
    const asdew = {
      1: 0,
      2: 2,
      3: 4,
      4: 5,
      5: 7,
      6: 9,
      7: 11,
      // 6: bsso(10),
      8: 12,
    };

    oaksd[num] = asdew[ind + 1] + push;
  }
}

export function getNoteScale(num, type, exto = 0) {
  const major = {
    1: 0,
    2: 2,
    3: 4,
    4: 5,
    5: 7,
    6: 9,
    7: 11,
    // 6: bsso(10),
    8: 12,
  };

  const asdfre = {
    major,
  }[type][num];

  return asdfre + exto;
}

export function getChordMain(note, type, pitch = 0) {
  const iasdfr = {
    maj: majorRend,
    min: minorRend,
    sus4: () => susRend(note, 5),
    maj7: seventhRend,
  };

  const chordFunc = iasdfr[type];

  let typo = chordFunc(note);
  let newarra = typo.map((ansd) => ansd + pitch);

  bearlog.lug(`___ getChordMain ___`, { type, typo });

  return newarra;
}
